import React from 'react';

const PurchaseCountTable = ({ PurchaseCountTableinfo }) => {
  return (
    <div className="table-responsive-food -z-0">
      <table className="table-food">
        <thead className="table-background ">
          <tr className="sticky-header bg-white">
            <th>Item</th>
            <th>Count</th>
          </tr>
        </thead>
        {/* Check if PurchaseCountTableinfo is not empty and map over it */}
        {PurchaseCountTableinfo.length > 0 ? (
          PurchaseCountTableinfo.map((item, index) => (
            <tr key={index}>
              <td>{item.Name}</td>
              <td>{item.purchase_count}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="2">No data available</td>
          </tr>
        )}
      </table>
    </div>
  );
};

export default PurchaseCountTable;
